import selects from 'scoreboard/components/selects'
import arrayToHash from 'scoreboard/components/array-to-hash'
import _ from 'lodash'

/**
 * Renders a multi-select for choosing ranges
 * @param el the <select> element
 * @param ranges the ranges for a field
 * @param rangeIds the rangeIds that should be pre-selected
 * @param {Object} [selectOptions] options that should be passed on to scoreboard-select
 */
function rangeSelectMultiple(el, ranges, rangeIds, selectOptions = {}) {
	var selected = arrayToHash(rangeIds)
	var options = _.chain(ranges)
		.cloneDeep()
		.forEach(function (option) {
			if (selected[option.id]) {
				option.selected = true
			}
		})
		.value()
	if (!_.isEmpty(ranges)) {
		selects.filtering(el, _.extend({
			multiple: true,
			options: options,
			accessors: {value: 'id'}
		}, selectOptions))
	}
}

export default rangeSelectMultiple

rangeSelectMultiple.__filename__ = 'datasets/filters/range-select-multiple.js'
